import React from 'react';
import PropTypes from 'prop-types';

function Next({ size = 40, className, onClick }) {
  return (
    <svg className={className} width={size} height={size} onClick={onClick} style={{cursor: `pointer`}} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#242424"/>
      <path d="M16.5898 24.59L21.1698 20L16.5898 15.41L17.9998 14L23.9998 20L17.9998 26L16.5898 24.59Z" fill="white"/>
    </svg>
  )
}

Next.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired
}

export default Next;
